import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ErrorContainer,
  ErrorLogo,
  ErrorStatus,
  ErrorText,
  ErrorLink
} from './styled';

interface ErrorPageProps {
  statusCode: number;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ statusCode }) => {
  const { t } = useTranslation();
  return (
    <ErrorContainer>
      <ErrorLogo href="/">bina.az</ErrorLogo>
      <ErrorStatus>{statusCode}</ErrorStatus>
      <ErrorText>{t('pages.error.error_text')}</ErrorText>
      <ErrorLink href="/">{t('pages.error.link_to_main')}</ErrorLink>
    </ErrorContainer>
  );
};
